<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="lastName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="userName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'firstName'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control initialDefaultValue="All">
                    <wbo-select-options>
                        <wbo-select-option value="excludeUnemployed" label="wbo.employee.option.status.excludingUnemployed">
                        </wbo-select-option>
                        <wbo-select-option value="All" label="wbo.employee.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option value="Casual" label="wbo.employee.option.status.casual">
                        </wbo-select-option>
                        <wbo-select-option value="Part Time" label="wbo.employee.option.status.partTime">
                        </wbo-select-option>
                        <wbo-select-option value="Permanent Part Time" label="wbo.employee.option.status.permanentPartTime">
                        </wbo-select-option>
                        <wbo-select-option value="Full Time" label="wbo.employee.option.status.fullTime">
                        </wbo-select-option>
                        <wbo-select-option value="Unemployed" label="wbo.employee.option.status.unEmployed">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'accessRoleId'">
                <wbo-access-role-multi-select-search-control></wbo-access-role-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'employeeCode'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="lastName"></wbo-main-search-column>
        <wbo-column field="firstName"></wbo-column>
        <wbo-column field="userName"></wbo-column>
        <wbo-column field="homePhone"></wbo-column>
        <wbo-column field="mobilePhone"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-column field="position"></wbo-column>
        <wbo-column field="accessRoleName"></wbo-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action [discontinueName]="'wbo.employee.search.button.unemploy'" [recontinueName]="'wbo.employee.search.button.employ'"
                                           [discontinueMessageKey]="'wbo.employee.search.prompt.unemploy.message'"
                                           [discontinueTitleKey]="'wbo.employee.search.prompt.unemploy.heading'" [allowRecontinue]="false">
            </wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
